import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=1c70d142&scoped=true"
import script from "./DueDate.vue?vue&type=script&lang=js"
export * from "./DueDate.vue?vue&type=script&lang=js"
import style0 from "./DueDate.vue?vue&type=style&index=0&id=1c70d142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70d142",
  null
  
)

export default component.exports